export default __webpack_public_path__ + "static/Medellin-disabled-75d76a32c4ac0cbfba8ee9e4ccc52a66.svg";